/** get a value cycling to the beginning on overflow */
export default function pickFromCarousel<T>(values: T[], index: number) {
    return values?.[index % values.length]
}
